// KOMPA 2.0 — Caracas (UTC-4) display helpers.
//
// Business rule: all backend timestamps are stored in UTC but MUST be
// displayed to the user in Caracas local time. Venezuela has been fixed at
// UTC-04:00 since 2016 — we use a static offset so the build works even
// where `Intl` tzdata is incomplete.

const CARACAS_OFFSET_MIN = -4 * 60;

function toCaracasDate(value) {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  // Shift by (browserOffset - caracasOffset). getTimezoneOffset returns
  // MINUTES to ADD to local time to get UTC — so Caracas shifted is:
  const localOffset = d.getTimezoneOffset();         // min for browser tz
  const diff = (localOffset - (-CARACAS_OFFSET_MIN)) * 60 * 1000;
  return new Date(d.getTime() - diff);
}

const pad = (n) => String(n).padStart(2, '0');

export function formatCaracasDateTime(value) {
  const d = toCaracasDate(value);
  if (!d) return '—';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function formatCaracasDate(value) {
  const d = toCaracasDate(value);
  if (!d) return '—';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function formatCaracasTime(value) {
  const d = toCaracasDate(value);
  if (!d) return '—';
  return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

export function formatCaracasRelative(value) {
  const d = toCaracasDate(value);
  if (!d) return '—';
  const now = toCaracasDate(new Date());
  const diffMs = now.getTime() - d.getTime();
  const diffMin = Math.round(diffMs / 60000);
  if (diffMin < 1) return 'hace segundos';
  if (diffMin < 60) return `hace ${diffMin} min`;
  const hrs = Math.floor(diffMin / 60);
  if (hrs < 24) return `hace ${hrs} h`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `hace ${days} d`;
  return formatCaracasDate(value);
}

export const TIMEZONE_LABEL = 'Caracas (UTC-4)';
